/**
 * Pure click behavior for an Inbox `NOTIFICATION` row (R4, Done when 6): navigate to the record's
 * link (if any), then mark the notification read. Extracted out of `InboxNotificationRow` so it has
 * proof — `ActionCenterTasks.tsx` is outside `src/ui`, so a `.tsx` rendering test there is not
 * collected by jest (`jest.config.ts` `testMatch`).
 */
export interface HandleInboxNotificationClickArgs {
  link: string | null;
  navigate: (link: string) => void;
  markRead: () => void;
}

export const handleInboxNotificationClick = (args: HandleInboxNotificationClickArgs): void => {
  if (args.link) {
    args.navigate(args.link);
  }
  args.markRead();
};
